import actionTypes from 'redux/actionTypes';

export const toggleMobileDrawer = () => ({
    type: actionTypes.MOBILE_DRAWER_TOGGLE,
});
